/** Vimeo id → title, from Vimeo's oEmbed API on the day the plan was executed. */
export const VIDEO_TITLES = {
  511337314: "Road Safety Audit 3D: SideBySide - 3D vs. 2D",
  588556437: "RSA 3D Technology: Henderson Interchange | Sight Distance Analysis | Henderson, NV",
  454349029: "Road Safety Audit 3D: Stopping Sight Distance Mobile LiDAR Collection",
  380993746: "3D RSA_Results",
  511337194: "Road Safety Audit 3D: Intersection Sight Distance",
  411942965: "3D Visualization: Bridge Design/Existing",
  411944003: "3D Visualization: Hampton Roads Express Network Project",
  411944670: "3D Visualization: I-440 Glenwood Ave.",
  411945641: "3D Visualization: Navigator",
  411945992:
    "3D Visualization: Washington Street Bridge Replacement Project Video - Construction Staging",
  412015851: "Navigator - Asset Creation",
  419792308: "3D Visualization: Photorealism",
  419792477: "3D Visualization: Photorealism 2",
  427330988: "3D Visualization: Frank J. Wood Bridge near Bruswick, Maine - Flyby Raytrace",
  428070028: "3D Visualization: Washington Street Bridge Raytrace DriveThru",
  446945299: "3D Visualization: Frank J. Wood Bridge near Brunswick, Maine - Raytrace Flyby",
};
export const videoTitle = (id) => VIDEO_TITLES[id] || "Video";
